import PropTypes from 'prop-types';
import {Enums} from '_app/utils';
import accessibilityFileShape from './accessibilityFileShape';

const reviewStatuses = Enums.getType('reviewStatuses');
const mediaTypes = Enums.getType('mediaTypes');

export default PropTypes.shape({
	complianceID: PropTypes.string,
	createDate: PropTypes.instanceOf(Date).isRequired,
	deleteDate: PropTypes.instanceOf(Date),
	disclaimer: PropTypes.string,
	id: PropTypes.number.isRequired,
	mediaID: PropTypes.number.isRequired,
	modifyDate: PropTypes.instanceOf(Date).isRequired,
	partnerID: PropTypes.string.isRequired,
	status: PropTypes.oneOf([
		reviewStatuses.TO_BE_REVIEWED,
		reviewStatuses.DENIED,
		reviewStatuses.ACTION_REQUIRED,
		reviewStatuses.APPROVED
	]).isRequired,
	version: PropTypes.number.isRequired,
	description: PropTypes.string,
	downloadLink: PropTypes.string,
	emailBody: PropTypes.string,
	externalMediaID: PropTypes.string,
	headerGraphicURL: PropTypes.string,
	headerOption: PropTypes.number,
	internalDescription: PropTypes.string,
	name: PropTypes.string,
	sourceContentImage: PropTypes.string,
	sourceContentUrl: PropTypes.string,
	subject: PropTypes.string,
	thumbnailLink: PropTypes.string,
	thumbnailLinkUrl: PropTypes.string,
	trackListArray: PropTypes.arrayOf(accessibilityFileShape),
	type: PropTypes.oneOf([
		mediaTypes.VIDEO,
		mediaTypes.PRESENTATION,
		mediaTypes.ARTICLE,
		mediaTypes.AUDIO,
		mediaTypes.EMAIL,
		mediaTypes.EBOOK,
		mediaTypes.INFOGRAPHIC,
		mediaTypes.ONESHEET,
		mediaTypes.NEWSLETTER,
	]),
	url: PropTypes.string,
	viewUrl: PropTypes.string
});